
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/[articleSlug]",
      function () {
        return require("private-next-pages/articles/[articleSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/[articleSlug]"])
      });
    }
  